var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox scan-authority" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["distribution:store:card:verifier:list"],
              expression: "['distribution:store:card:verifier:list']",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "page-tip" }, [
            _vm._v(" 这里配置"),
            _c("strong", [_vm._v("哪些用户可以在 App 端扫码核销本门店的卡券")]),
            _vm._v(
              "。授权后对方的「我的」页面才会出现扫码入口， 也才能扫用户的卡券码完成核销；没授权的账号看不到入口，扫了也会被后端拒绝。 授权对象是对方的 App 账号（用手机号找人），不需要给他开门店后台账号。数据范围是当前登录账号绑定的门店。 "
            ),
          ]),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["distribution:store:card:verifier:save"],
                  expression: "['distribution:store:card:verifier:save']",
                },
              ],
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "添加人员" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "输入对方手机号" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.add($event)
                      },
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "phone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "或用户ID" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "140px" },
                    attrs: { placeholder: "选填" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.add($event)
                      },
                    },
                    model: {
                      value: _vm.form.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "uid", _vm._n($$v))
                      },
                      expression: "form.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.add },
                    },
                    [_vm._v("添加扫码权限")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "搜索" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { clearable: "", placeholder: "昵称 / 手机号" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "已启用", value: true },
                      }),
                      _c("el-option", {
                        attrs: { label: "已停用", value: false },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户ID", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "用户", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "user-cell" },
                          [
                            row.avatar
                              ? _c("el-image", {
                                  staticClass: "user-avatar",
                                  attrs: { src: row.avatar, fit: "cover" },
                                })
                              : _vm._e(),
                            _c("div", [
                              _c("div", [_vm._v(_vm._s(row.nickname || "-"))]),
                              _c("div", { staticClass: "sub-text" }, [
                                _vm._v(_vm._s(row.phone || "-")),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "扫码权限", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-switch", {
                          on: {
                            change: function (val) {
                              return _vm.toggle(row, val)
                            },
                          },
                          model: {
                            value: row.status,
                            callback: function ($$v) {
                              _vm.$set(row, "status", $$v)
                            },
                            expression: "row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "operator", label: "操作人", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "授权时间", width: "160" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "90", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:card:verifier:save",
                                ],
                                expression:
                                  "['distribution:store:card:verifier:save']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(row)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "pagination",
            attrs: {
              background: "",
              "current-page": _vm.query.page,
              "page-size": _vm.query.limit,
              total: _vm.total,
              layout: "total, prev, pager, next, jumper",
            },
            on: { "current-change": _vm.onPageChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }